import { z } from 'zod';
export const QualityLevelSchema = z.enum(['low', 'medium', 'high']);
export const QUALITY_TOKEN_BASE = {
    low: 1,
    medium: 5,
    high: 20,
};
/**
 * Fixed-size multipliers, relative to the 1024x1024 base. Each value is the
 * size's pixel area divided by 1024x1024 (clamped to 5.0), which is what it
 * costs to generate upstream: gpt-image-2 bills by resolution, so a 1536x1024
 * landscape (~1.5x the pixels) costs ~1.5x a square. This keeps the fixed-size
 * table consistent with the area formula used for custom sizes. Keys match the
 * FixedSize enum values.
 */
export const SIZE_MULTIPLIER = {
    '1024x1024': 1.0,
    '1024x1536': 1.5,
    '1536x1024': 1.5,
    '2048x2048': 4.0,
    '3840x2160': 5.0,
};
export function resolveSizeMultiplier(size) {
    if (typeof size === 'string') {
        const known = SIZE_MULTIPLIER[size];
        if (known !== undefined)
            return known;
        // Parse "WxH" strings not in the table
        const parts = size.split('x');
        const w = Number(parts[0]);
        const h = Number(parts[1]);
        if (!isNaN(w) && !isNaN(h)) {
            return Math.max(0.8, Math.min(5.0, (w * h) / (1024 * 1024)));
        }
        return 1.0;
    }
    // Custom size object
    const { width, height } = size;
    return Math.max(0.8, Math.min(5.0, (width * height) / (1024 * 1024)));
}
export function computeTokenCost(input) {
    const base = QUALITY_TOKEN_BASE[input.quality];
    const multiplier = resolveSizeMultiplier(input.size);
    return Math.ceil(base * multiplier);
}
export function describeTokenCost(input) {
    const cost = computeTokenCost(input);
    const sizeLabel = typeof input.size === 'string' ? input.size : `${input.size.width}x${input.size.height}`;
    return `${cost} token${cost === 1 ? '' : 's'} (${input.quality} · ${sizeLabel})`;
}
//# sourceMappingURL=index.js.map